import { Building2, FileText } from "lucide-react";

export default function AdminInquiriesTab({
  inquiries,
  onCreateInvoice
}) {
  return (
    <div className="space-y-3">
      {inquiries.length === 0 ? (
        <div className="bg-white rounded-xl p-8 text-center">
          <Building2 className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <h3 className="font-semibold text-gray-900">No corporate inquiries</h3>
          <p className="text-gray-500 mt-1">Inquiries from the /corporate page will appear here.</p>
        </div>
      ) : inquiries.map((inq) => (
        <div key={inq.id} className="bg-white rounded-xl p-4 shadow-sm">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h3 className="font-semibold text-gray-900">{inq.company_name}</h3>
              <p className="text-sm text-gray-600">{inq.contact_name} • {inq.email}</p>
              <div className="flex gap-4 mt-2 text-xs text-gray-500">
                {inq.company_size && <span>Size: {inq.company_size}</span>}
                {inq.venue_count && <span>Venues: {inq.venue_count}</span>}
              </div>
              {inq.message && <p className="mt-2 text-sm text-gray-700 bg-gray-50 p-2 rounded">{inq.message}</p>}
            </div>
            <button 
              onClick={() => onCreateInvoice(inq)} 
              className="btn-primary text-sm flex items-center gap-1"
            >
              <FileText className="w-4 h-4" /> Create Invoice
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
